<template>
  <template v-if="map && api && accommodations?.length">
    <template v-if="$screen.isSmall">
      <RedesignMapSearchInfoWindow
        ref="cardContentRef"
        :key
        class="absolute inset-x-2 bottom-8 top-auto"
        :trip
        :accommodations
        :loading
        :cta="isCtaMobileEnabled"
        compact
        @close="$emit('close')"
      />
    </template>
    <template v-else>
      <OverlayView
        :key
        :position="toLatLng(item.coords)"
        :map
        :api
        pane="floatPane"
      >
        <RedesignMapSearchInfoWindow
          ref="cardContentRef"
          :key
          class="mb-8 w-[310px] -translate-x-1/2"
          :trip
          :accommodations
          :loading
          :cta="isCtaMobileEnabled"
          vertical
          compact
          @close="$emit('close')"
        />
      </OverlayView>
    </template>
  </template>
</template>

<script setup lang="ts">
import { sortBy } from 'lodash-es'
import { toLatLng } from '~/utils/map'
import { RedesignMapSearchInfoWindow } from '#components'

const props = defineProps<{
  item: MapItemAccom
  filters: SearchApiParams
  map: google.maps.Map
  api: typeof google.maps
}>()

const emit = defineEmits<{ close: [] }>()

const cardContentRef = useTemplateRef('cardContentRef')
const isCtaMobileEnabled = useFlag('srp-accom-card-cta-btn-mobile')

onClickOutside(cardContentRef as Ref<any>, () => emit('close'), {
  capture: true,
})

const trip = computed(() => getTripParams(props.filters as Params))

const { data, isLoading: loading } = useRedesignSearchQuery(() => ({
  code: props.item.docs.map(({ code }) => code),
  checkin: props.filters.checkin,
  checkout: props.filters.checkout,
  duration: props.filters.duration,
  pax: props.filters.pax,
}))

const accommodations = computed(() => sortBy(data.value?.docs, 'trip.price'))

const key = computed(
  () => JSON.stringify(props.item.coords) || accommodations.value?.[0].code,
)

const contentHeight = ref(0)

watchImmediate(
  () => cardContentRef.value?.$el,
  async (el) => {
    if (!el) return
    await nextTick()
    contentHeight.value = el.getBoundingClientRect().height
  },
)

watchImmediate(
  [contentHeight, () => props.item.coords],
  async ([height, coords]) => {
    if (!height || !coords) return

    // center to marker
    props.map.panTo(toLatLng(coords))

    // adjust to card content height
    props.map.panBy(0, Math.round(height / 2))
  },
)
</script>
